"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SectionResultsIntro_1 = require("./SectionResultsIntro");

exports.SectionResultsIntro = SectionResultsIntro_1.default;